import { useLocation } from 'react-router-dom';

import qs, { ParsedQs } from 'qs';

export const useSearchParams = <T extends ParsedQs>(): T => {
  const { search } = useLocation();

  return qs.parse(search?.replace(/^\?/, '')) as T;
};
